import { Response } from '@marketplace-web/shared/api-client'

import { GetShippingInstructionsResp } from 'types/api/response/get-shipping-instructions-resp'

import { transformShippingInstructionsDto } from 'data/transformers/shipping-instructions'

export const transformShippingInstructionsResponse = (
  response: Response<GetShippingInstructionsResp>,
) => transformShippingInstructionsDto(response.shipping_instructions)
